import React from 'react';
import Icon from '../../../components/AppIcon';

const SupersetIndicator = ({ 
  currentExercise, 
  nextExercise, 
  supersetPosition,
  totalSupersetExercises = 2,
  onNextExercise 
}) => {
  if (!nextExercise) return null;

  const getPositionLabel = (position) => {
    const labels = ['A1', 'B1', 'A2', 'B2', 'A3', 'B3'];
    return labels?.[position - 1] || `${position}`;
  };

  const getNextPositionLabel = (position) => {
    const labels = ['A1', 'B1', 'A2', 'B2', 'A3', 'B3'];
    return labels?.[position] || `${position + 1}`;
  };

  return (
    <div className="bg-secondary/10 rounded-2xl p-6 border-2 border-secondary/20">
      <div className="text-center mb-6">
        <div className="flex items-center justify-center space-x-3 mb-4">
          <Icon name="Link" size={32} className="text-secondary" />
          <h3 className="text-2xl font-bold text-secondary">
            Superset Exercise
          </h3>
        </div>
        <p className="text-lg text-muted-foreground">
          Complete this set, then move to the next exercise
        </p>
      </div>
      {/* Exercise Flow Visualization */}
      <div className="flex items-center justify-center space-x-4 mb-6">
        {/* Current Exercise */}
        <div className="text-center">
          <div className="w-16 h-16 bg-secondary rounded-full flex items-center justify-center mb-3">
            <span className="text-white font-bold text-lg">
              {getPositionLabel(supersetPosition)}
            </span>
          </div>
          <p className="text-sm font-semibold text-foreground truncate max-w-24">
            {currentExercise?.name}
          </p>
          <p className="text-xs text-secondary">Current</p>
        </div>

        {/* Arrow */}
        <div className="flex flex-col items-center">
          <Icon name="ArrowRight" size={32} className="text-secondary" />
          <p className="text-xs text-muted-foreground mt-1">Next</p>
        </div>

        {/* Next Exercise */}
        <div className="text-center">
          <div className="w-16 h-16 bg-muted border-2 border-secondary border-dashed rounded-full flex items-center justify-center mb-3">
            <span className="text-secondary font-bold text-lg">
              {getNextPositionLabel(supersetPosition)}
            </span>
          </div>
          <p className="text-sm font-semibold text-foreground truncate max-w-24">
            {nextExercise?.name}
          </p>
          <p className="text-xs text-muted-foreground">Up Next</p>
        </div>
      </div>
      {/* Next Exercise Preview */}
      <div className="bg-surface rounded-xl p-4 border border-border">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <h4 className="text-lg font-semibold text-foreground mb-1">
              {nextExercise?.name}
            </h4>
            <div className="flex items-center space-x-4 text-sm text-muted-foreground">
              <span>{nextExercise?.targetReps} reps</span>
              <span>•</span>
              <span>{nextExercise?.weight} {nextExercise?.unit}</span>
              <span>•</span>
              <span>Level {nextExercise?.intensity}</span>
            </div>
          </div>
          
          <div className="w-12 h-12 bg-secondary/10 rounded-lg flex items-center justify-center">
            <Icon 
              name={nextExercise?.type === 'dynamic' ? 'Activity' : 'Timer'} 
              size={24} 
              className="text-secondary" 
            />
          </div>
        </div>
      </div>
      {/* Instructions */}
      <div className="mt-6 p-4 bg-accent rounded-xl">
        <div className="flex items-start space-x-3">
          <Icon name="Info" size={20} className="text-primary mt-1" />
          <div>
            <p className="text-sm font-medium text-foreground mb-1">
              Superset Instructions:
            </p>
            <p className="text-sm text-muted-foreground">
              After completing this set, you'll immediately move to {nextExercise?.name}. 
              Rest only after completing both exercises.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupersetIndicator;